var _path, _path2, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 21,
    viewBox: "0 0 20 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_840_2457)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0.5H4C1.79086 0.5 0 2.29086 0 4.5V16.5C0 18.7091 1.79086 20.5 4 20.5H16C18.2091 20.5 20 18.7091 20 16.5V4.5C20 2.29086 18.2091 0.5 16 0.5Z",
    fill: "#0516C8"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_840_2457",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 5,
    y: 5,
    width: 10,
    height: 11
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15 5.5H5V15.5H15V5.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_840_2457)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 7.39938C14.6281 7.5625 14.2319 7.67062 13.8187 7.72312C14.2437 7.46938 14.5681 7.07062 14.7206 6.59C14.3244 6.82625 13.8869 6.99313 13.4206 7.08625C13.0444 6.68563 12.5081 6.4375 11.9231 6.4375C10.7881 6.4375 9.87437 7.35875 9.87437 8.48813C9.87437 8.65062 9.88812 8.80687 9.92188 8.95562C8.2175 8.8725 6.70938 8.05563 5.69625 6.81125C5.51937 7.11813 5.41563 7.46938 5.41563 7.8475C5.41563 8.5575 5.78125 9.18687 6.32625 9.55125C5.99687 9.545 5.67375 9.44938 5.4 9.29875C5.4 9.305 5.4 9.31312 5.4 9.32125C5.4 10.3175 6.11062 11.145 7.0425 11.3356C6.87562 11.3812 6.69375 11.4031 6.505 11.4031C6.37375 11.4031 6.24125 11.3956 6.11687 11.3681C6.3825 12.18 7.13625 12.7769 8.0325 12.7962C7.335 13.3419 6.44938 13.6706 5.49063 13.6706C5.3225 13.6706 5.16125 13.6631 5 13.6425C5.90812 14.2281 6.98438 14.5625 8.145 14.5625C11.9175 14.5625 13.98 11.4375 13.98 8.72875C13.98 8.63812 13.9769 8.55063 13.9725 8.46375C14.3794 8.175 14.7212 7.81438 15 7.39938Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_840_2457"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.cc9905e8af1093ccd1364d96e2cd1581.svg";
export { ForwardRef as ReactComponent };